import React, { useState, useEffect, useRef } from 'react';

const SaveAsMealPlanModal = ({ isOpen, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setName('');
      setError('');
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      } else if (event.key === 'Tab') {
        const focusableElements = modalRef.current.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
          }
        }
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const handleSave = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Meal plan name cannot be empty.');
      return;
    }
    onSave(name);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        <form onSubmit={handleSave}>
          <div className="modal-header">
            <h2>Save meal plan as...</h2>
            <button title="Close" type="button" onClick={onClose} className="icon-button close-button"><i className="material-icons">close</i></button>
          </div>
          <div className="modal-body">
          {error && <p className="error-message">{error}</p>}
          <div className="search-input-container">
            <input
              ref={inputRef}
              type="text"
              placeholder="Enter new meal plan name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {name && <button title="Clear name" type="button" onClick={() => { setName(''); inputRef.current.focus(); }} className="clear-input-button"><i className="material-icons">close</i></button>}
          </div>
          </div>
          <div className="modal-footer">
            <button title="Save and close" type="submit">Save and close</button>
            <button title="Cancel" type="button" onClick={onClose} className="cancel-button">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SaveAsMealPlanModal;